import { startCase } from 'lodash/fp';
import { ReactNode } from 'react';

import {
  MediumHeaderContainer,
  TableNullStateContainer,
} from 'dashboard/apps/InquiryTemplateEditor/InquiryPreview/shared';
import { CheckStub } from 'dashboard/models/simulate/stubs';
import Table, {
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from 'design-system/components/Table';
import { Paragraph } from 'design-system/components/Text';
import { CHECK_DISPLAY_CONFIG } from 'lib/constants/check';

interface VerificationChecksDisplayProps {
  checkStubs: CheckStub[];
  rightElement?: ReactNode;
}

export const VerificationChecksTable = ({
  checkStubs,
  rightElement,
}: VerificationChecksDisplayProps) => {
  return (
    <>
      <MediumHeaderContainer>
        Verification Checks
        {rightElement}
      </MediumHeaderContainer>
      <Table>
        <TableHead>
          <TableHeaderCell>Check name</TableHeaderCell>
          <TableHeaderCell>Failure reason</TableHeaderCell>
        </TableHead>
        {checkStubs.length > 0 && (
          <TableBody>
            {checkStubs.map((stub, idx) => {
              const checkName = stub.name;
              const checkConfig = CHECK_DISPLAY_CONFIG[checkName];
              const checkNameReadable = checkConfig?.name || startCase(checkName);
              const reasons = stub.reasons;
              const reasonReadable = reasons.length > 0 ? checkConfig.reasons[reasons[0]] : null;

              return (
                <TableRow key={idx}>
                  <TableCell breakWord>{checkNameReadable}</TableCell>
                  <TableCell breakWord>{reasonReadable}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        )}
      </Table>
      {checkStubs.length === 0 && (
        <TableNullStateContainer>
          <Paragraph>No overrides specified.</Paragraph>
        </TableNullStateContainer>
      )}
    </>
  );
};
